module.exports = __webpack_public_path__ + "img/logo-derek.7a3598b6.svg";